export default {
  BUSINESS_UNIT_CONTACT_DETAILS: null,
}
